import React, { useEffect, useState, useRef } from "react";
import {
  Typography,
  Stack,
  Box,
  Grid,
  Button,
  TextField,
  Divider,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import ReactToPrint from "react-to-print";
import moment from "moment";
import { useQuery } from "@apollo/client";
import { ToWords } from "to-words";
//date picker
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
//Icons
import { SiMicrosoftexcel } from "react-icons/si";
import { BsPrinter } from "react-icons/bs";
//Import from project
import "../../Style/pagestyle.scss";
import { currencyFormat } from "../../Function/DynamicFn";
import school from "../../Assets/goglobal-school.png";
import symbol from "../../Assets/tacteing.jpg";
import { GET_CASH_RECIEVING_VOUCHER } from "../../Schema/Report";
import { useDownloadExcel } from "react-export-table-to-excel";
import { ConvertToKhmerWordsDollar } from "../Include/ReadCurrency";
import LoadingPage from "../Include/LoadingPage";
import EmptyData from "../Include/EmptyData";
import { SelectIncomeShift } from "../Include/DynamicSelect";

export default function CashReceivingVoucher() {
  const [fromDate, setFromDate] = useState(moment().startOf("day"));
  const [toDate, setToDate] = useState(moment());
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [incomeType, setIncomeType] = useState("None");
  const [incomeShiftVal, setIncomeShiftVal] = useState({ id: "", title: "" });

  const toWords = new ToWords({
    localeCode: "en-US",
    converterOptions: {
      currency: false,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: true,
    },
  });

  const [showVoucherNum, setShowVoucherNum] = useState(false);
  const voucherNumFromLocal = JSON.parse(
    localStorage.getItem("voucherNumFromLocal")
  );
  const [voucherNum, setVoucherNum] = useState(
    voucherNumFromLocal ? voucherNumFromLocal : "0000"
  );
  const handleVoucherNum = (text) => {
    setVoucherNum(text);
    localStorage.setItem("voucherNumFromLocal", JSON?.stringify(text));
  };

  //Export to excel
  const [checkExport, setCheckExport] = useState(false);
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Cash-receiving-report",
    sheet: "Cash-receiving-report",
  });
  const handleExportExcel = () => {
    setCheckExport(true);
    setTimeout(() => {
      onDownload();
      setCheckExport(false);
    }, 2000);
  };

  // ==================================== Print PDF ======================================
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const componentRef = useRef(null);
  const reactToPrintContent = () => {
    return componentRef.current;
  };

  const reactToPrintTrigger = () => {
    return (
      <Button
        onClick={handleOpen}
        className="btn-create"
        startIcon={<BsPrinter alt="CreateIcon" className="icon-add" />}
      >
        Print
      </Button>
    );
  };

  //======================================= Get Report =====================================
  const { refetch } = useQuery(GET_CASH_RECIEVING_VOUCHER, {
    variables: {
      fromDate: fromDate ? moment(fromDate)?.format("YYYY-MM-DD") : null,
      toDate: fromDate ? moment(fromDate)?.format("YYYY-MM-DD") : null,
      // toDate: toDate ? moment(toDate)?.format("YYYY-MM-DD") : null,
      incomeType: incomeType === "None" ? [] : [incomeType],
      incomeShiftId: incomeShiftVal?.id ? incomeShiftVal?.id : "",
    },
    onCompleted: ({ cashReceivingVocher }) => {
      // console.log("cashReceivingVocher::", cashReceivingVocher);
      setTableData(cashReceivingVocher);
      setLoading(false);
    },
  });

  useEffect(() => {
    refetch();
  }, [fromDate, toDate, incomeType, incomeShiftVal?.id]);

  const { totalPrice } = tableData?.reduce(
    (acc, e) => {
      e?.listOfIncomeType?.forEach((f) => {
        acc.totalPrice += f.totalAmount || 0;
      });
      return acc;
    },
    { totalPrice: 0 }
  );

  const [dollars, cents] = totalPrice?.toFixed(2).split(".");
  // const getAountAsWord = `${toWords.convert(dollars)} USD and ${toWords.convert(cents)} cents only`;
  const firstAmount = toWords.convert(dollars);
  const secondAmount = toWords.convert(cents);
  const cutFirstLetter = firstAmount?.slice(0, 1);
  const remainWordLetter = firstAmount?.slice(1, 2000).toString();

  const formatNumber = (number) => new Intl.NumberFormat().format(number);

  return (
    <div className="page-container">
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={4} sm={4} md={3} lg={2} xl={2}>
            <Typography className="search-head-title">From</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={fromDate}
                inputFormat="dd-MM-yyyy"
                className="select-date"
                onChange={(newValue) => {
                  setLoading(true);
                  setFromDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>

          {/* <Grid item xs={4} sm={4} md={3} lg={2} xl={2}>
            <Typography className="search-head-title">To</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={toDate}
                inputFormat="dd-MM-yyyy"
                className="select-date"
                onChange={(newValue) => {
                  setLoading(true);
                  setToDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid> */}

          <Grid item xs={4} sm={4} md={3} lg={2} xl={2}>
            <Typography className="search-head-title">Income Type</Typography>
            <FormControl fullWidth size="small" className="search-field">
              <Select
                fullWidth
                value={incomeType}
                onChange={(e) => {
                  setIncomeType(e.target?.value);
                }}
              >
                <MenuItem value="None">None</MenuItem>
                <MenuItem value="Income">Income</MenuItem>
                <MenuItem value="AdminFee">AdminFee</MenuItem>
                <MenuItem value="Tuition">Tuition</MenuItem>
                <MenuItem value="Trail One Month">Trail One Month</MenuItem>
                <MenuItem value="Meal Service">Meal Service</MenuItem>
                <MenuItem value="Transportation Service">
                  Transportation Service
                </MenuItem>
                <MenuItem value="School Uniform">School Uniform</MenuItem>
                <MenuItem value="Material">Material</MenuItem>
                <MenuItem value="Music">Music</MenuItem>
                <MenuItem value="Computer">Computer</MenuItem>
                <MenuItem value="Dance">Dance</MenuItem>
                <MenuItem value="Summer Class">Summer Class</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <Typography className="search-head-title">Income shift</Typography>
            <SelectIncomeShift
              className="search-field"
              fromDate={fromDate}
              toDate={toDate}
              disabled={fromDate && toDate ? false : true}
              selectedVal={incomeShiftVal}
              setSelectedVal={setIncomeShiftVal}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
            <Stack direction="row" justifyContent="right" spacing={1}>
              <Button
                className="btn-create"
                onClick={handleExportExcel}
                startIcon={
                  <SiMicrosoftexcel style={{ height: "18px", width: "18px" }} />
                }
              >
                Export
              </Button>
              <ReactToPrint
                content={reactToPrintContent}
                documentTitle={`Cash-Receiving-Voucher`}
                removeAfterPrint
                trigger={reactToPrintTrigger}
              />

              {/* <ExportTuitionReport
                loading={loading}
                tableData={tableData}
                paginationData={paginationData}
                tableRef={tableRef}
              /> */}
            </Stack>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ marginTop: "20px" }}>
        <Box
          ref={componentRef}
          sx={{ bgcolor: "#fff", borderRadius: "10px" }}
          className="dibursement-print-container"
        >
          <Grid container>
            <Grid item xs={3}>
              <Stack direction="column">
                <img src={school} alt="school" className="logo-size" />
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Stack direction="column">
                <Stack justifyContent="center" alignItems="center">
                  <Typography className="disbursement-title-kh">
                    ព្រះរាជាណាចក្រកម្ពុជា
                  </Typography>
                  <Typography className="disbursement-title">
                    Kingdom Of Cambodia
                  </Typography>
                  <Typography className="disbursement-title-kh">
                    ជាតិ សាសនា ព្រះមហាក្សត្រ
                  </Typography>
                  <Typography className="disbursement-title">
                    Nation Region King
                  </Typography>
                  <img src={symbol} alt="Tacteing" width="145px" />
                </Stack>

                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ paddingTop: "55px" }}
                >
                  <Typography className="disbursement-table-title">
                    សក្ខីប័ណ្ណទទួលសាច់ប្រាក់
                  </Typography>
                  <Typography className="disbursement-table-title-eng">
                    Cash Receiving Voucher
                  </Typography>
                </Stack>
              </Stack>
            </Grid>

            <Grid item xs={3}>
              <Stack
                direction="row"
                justifyContent="right"
                sx={{ paddingTop: "130px" }}
              >
                <Stack direction="row" justifyContent="right" spacing={8}>
                  <Typography className="number-text">លេខ ៖ </Typography>
                  {showVoucherNum === false ? (
                    <Typography
                      className="number-text"
                      onClick={() => setShowVoucherNum(!showVoucherNum)}
                      sx={{
                        textAlign: "right",
                      }}
                    >
                      {voucherNum}
                    </Typography>
                  ) : null}
                  {showVoucherNum ? (
                    <Typography className="number-text">
                      <TextField
                        size="small"
                        fullWidth
                        onMouseLeave={() => setShowVoucherNum(false)}
                        value={voucherNum}
                        onChange={(e) => handleVoucherNum(e?.target?.value)}
                      />
                    </Typography>
                  ) : null}
                </Stack>
              </Stack>
            </Grid>
          </Grid>

          <Box sx={{ paddingTop: "10px" }} ref={tableRef}>
            <table className="table-report-receiving-voucher">
              <tr>
                <th style={{ width: "12%" }}>
                  <div className="table-report-receiving-voucher-khmer">
                    កាលបរិច្ឆេទ
                  </div>
                  <div style={{ paddingTop: "2px" }}>Date</div>
                </th>
                <th style={{ width: "22%" }}>
                  <div className="table-report-receiving-voucher-khmer">
                    ប្រភេទចំណូល
                  </div>
                  <div style={{ paddingTop: "2px" }}>Income Type</div>
                </th>
                <th style={{ width: "43%" }}>
                  <div className="table-report-receiving-voucher-khmer">
                    លេខវិក័យបត្រ
                  </div>
                  <div style={{ paddingTop: "2px" }}>No.Invoice</div>
                </th>
                <th style={{ width: "18%" }}>
                  <div className="table-report-receiving-voucher-khmer">
                    ទឹកប្រាក់
                  </div>
                  <div style={{ paddingTop: "2px" }}>Amount</div>
                </th>
              </tr>
              {loading ? (
                <tr>
                  <td
                    colSpan={4}
                    className="table-report-receiving-voucher-nodata"
                  >
                    <LoadingPage />
                  </td>
                </tr>
              ) : (
                <>
                  {tableData?.length <= 0 ? (
                    <tr>
                      <td
                        colSpan={4}
                        className="table-report-receiving-voucher-nodata"
                      >
                        <EmptyData />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {/* Map over tableData if available */}
                      {tableData?.map((e, index) => (
                        <React.Fragment key={index}>
                          <tr>
                            <td
                              align="center"
                              rowSpan={e?.listOfIncomeType?.length + 1}
                            >
                              {moment(e?.date).format("DD-MMM-yyyy")}
                            </td>
                          </tr>

                          {e?.listOfIncomeType?.map((f, index2) => {
                            // console.log("f::", f?.totalAmount)
                            return (
                              <tr key={index2}>
                                <td
                                  style={{
                                    marginLeft: "8px",
                                    textAlign: "left",
                                  }}
                                >
                                  {index2 + 1}{" "}
                                  <span style={{ marginLeft: "10px" }}>
                                    {f?.incomeType}
                                  </span>
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                  }}
                                >
                                  {/* <Stack
                                    direction="row"
                                    spacing={0}
                                    flexWrap="wrap"
                                  >
                                    <div style={{ marginRight: "8px" }}> */}
                                  {f?.listOfInvoiceId
                                    ? f?.listOfInvoiceId?.join(", ")
                                    : "0"}
                                  {/* </div>
                                  </Stack> */}
                                </td>
                                <td align="center">
                                  {/* $ {formatNumber(f?.totalAmount)} */}
                                  {f?.totalAmount
                                    ? `${currencyFormat(f?.totalAmount)}`
                                    : "-"}
                                </td>
                              </tr>
                            );
                          })}
                        </React.Fragment>
                      ))}

                      {/* Total Row */}
                      <tr>
                        <td
                          className="table-report-receiving-voucher-total"
                          colSpan={3}
                        >
                          <span className="table-report-receiving-voucher-footer-khmer-moul">
                            សរុបទឹកប្រាក់
                          </span>
                          <span className="table-report-receiving-voucher-footer-eng">
                            (Total)
                          </span>
                        </td>
                        <td
                          className="table-report-receiving-voucher-total"
                          style={{
                            fontWeight: "bold",
                            border: "1px solid red !important",
                          }}
                        >
                          {/* $ {formatNumber(totalPrice)} */}
                          {currencyFormat(totalPrice)}
                        </td>
                      </tr>
                    </>
                  )}
                </>
              )}
            </table>

            <table style={{ width: "100%", display: "none" }}>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  នាយិការង
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  Deputy of School Principal
                </td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  ប្រធានកិច្ចការហិរញ្ញវត្ថុ
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  Financial Affairs Director
                </td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  អ្នករៀបចំ
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  Prepare by
                </td>
              </tr>
            </table>
          </Box>

          <Box sx={{ marginTop: "10px" }}>
            <Grid container spacing={0.5}>
              {/* <Grid item xs={2.5}>
                <Typography className="number-text">
                  ចំនួនទឹកប្រាក់ជាអក្សរ ៖
                </Typography>
              </Grid>
              <Grid item xs={9.5}>
                <Typography className="number-text">
                  {ConvertToKhmerWordsDollar(totalPrice)}
                </Typography>
              </Grid>
              <Grid item xs={2.5}>
                <Typography className="number-text">
                  Amount in words ៖
                </Typography>
              </Grid> */}
              {/* <Grid item xs={9.5}>
                <Typography className="number-text">
                  <span className="number-text" style={{ textTransform: "uppercase" }}>{cutFirstLetter}</span>
                  {ConvertToEnglishWordsDollar(totalPrice)}
                   {remainWordLetter}
                </Typography>
              </Grid> */}
              <Grid item xs={12}>
                <Stack direction="row" spacing={2}>
                  <Typography className="table-report-receiving-voucher-footer-khmer">
                    ចំនួនទឹកប្រាក់ជាអក្សរ
                  </Typography>
                  <Typography className="table-report-receiving-voucher-footer-khmer">
                    ៖ {ConvertToKhmerWordsDollar(totalPrice)}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack direction="row" spacing={2}>
                  <Typography className="table-report-receiving-voucher-footer-eng">
                    Amount in words
                  </Typography>
                  <Typography className="table-report-receiving-voucher-footer-eng">
                    <span className="table-report-receiving-voucher-footer-khmer">
                      ៖{" "}
                    </span>
                    <span className="table-report-receiving-voucher-footer-eng">
                      {cutFirstLetter}
                    </span>
                    <span className="number-text-lowercase">
                      {remainWordLetter}
                    </span>{" "}
                    USD and{" "}
                    <span className="number-text-lowercase">
                      {secondAmount} cents only
                    </span>
                    {/* <span className="table-report-receiving-voucher-footer-eng">{ConvertToEnglishWordsDollar(totalPrice)}</span> */}
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ marginTop: "20px" }}>
            <Grid container>
              <Grid item xs={4}>
                <Stack direction="column" alignItems="center">
                  <Typography className="disbursement-table-title">
                    នាយិការង
                  </Typography>
                  <Typography className="table-report-receiving-voucher-footer-eng">
                    Deputy of School Principal
                  </Typography>
                  <Typography className="disbursement-table-title" mt={10}>
                    វេត ស្រីម៉ៅ
                  </Typography>
                  <Divider
                    style={{
                      width: "100px",
                      marginTop: "2px",
                      border: "1px solid rgba(15, 129, 194, 0.5)",
                    }}
                  />
                  <Typography
                    className="table-report-receiving-voucher-footer-eng"
                    mt={1}
                  >
                    Date: .......................
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column" alignItems="center" mt={1}>
                  <Typography className="disbursement-table-title">
                    ប្រធាន
                  </Typography>
                  <Typography className="table-report-receiving-voucher-footer-eng">
                    Director
                  </Typography>
                  <Typography className="disbursement-table-title" mt={10}>
                    ខូវ ស៊ូខេង
                  </Typography>
                  <Divider
                    style={{
                      width: "100px",
                      marginTop: "2px",
                      border: "1px solid rgba(15, 129, 194, 0.5)",
                    }}
                  />
                  <Typography
                    className="table-report-receiving-voucher-footer-eng"
                    mt={1}
                  >
                    Date: .......................
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column" alignItems="center" mt={2}>
                  <Typography className="disbursement-table-title">
                    អ្នករៀបចំ
                  </Typography>
                  <Typography className="table-report-receiving-voucher-footer-eng">
                    Prepare by
                  </Typography>
                  <Typography className="disbursement-table-title" mt={10}>
                    ស៊ុន ផាត់សន
                  </Typography>
                  <Divider
                    style={{
                      width: "100px",
                      marginTop: "2px",
                      border: "1px solid rgba(15, 129, 194, 0.5)",
                    }}
                  />
                  <Typography
                    className="table-report-receiving-voucher-footer-eng"
                    mt={1}
                  >
                    Date: .......................
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
